<template>
  <div class="w-100 relative text-center">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AS',
};
</script>

<style scoped>

</style>
